Vue.component('ack-shop-3dps-links', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-shop-3dps-links',
  props:{
    isMobile: {
      type: Boolean
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...Vuex.mapGetters('localization', ['countryCode']),
    isUSorCA() {
      return this.countryCode.toUpperCase() === 'US' || this.countryCode.toUpperCase() === 'CA'
    },
  },
  mounted() {
    appLog.log('ack-shop-3dps-links mounted', LOG_TYPE.debug)
    
    
  },
  methods: {

    loadBundle(bundleTag){
      const descriptions = {
        'shop-3dps-1': 'A cost-effective chairside 3D printing solution for producing non-biocompatible applications, such as dental models.',
        'shop-3dps-2': 'A cost-effective chairside 3D printing solution for producing biocompatible dental indications.',
        'shop-3dps-3': 'A cost-effective chairside 3D printing solution for producing biocompatible dental indications, with an advanced option to cure with nitrogen.',
        'shop-3dps-4': 'A workhorse 3D printing solution for producing non-biocompatible applications, such as dental models.',
        'shop-3dps-5': 'A workhorse 3D printing solution for producing biocompatible dental indications, engineered to be simple to use and easy to delegate.',
        'sol-bundle-us-ca': 'A workhorse 3D printing solution for producing biocompatible dental indications, engineered to be simple to use and easy to delegate.',
        'shop-3dps-6': 'A workhorse 3D printing solution for producing biocompatible dental indications, with an advanced option to cure with nitrogen.',
        'shop-3dps-7': 'A powerful 3D printing solution for the high-volume production of biocompatible dental indications and orthodontic models.',
        'sol-plus-bundle-us-ca': 'A powerful 3D printing solution for the high-volume production of biocompatible dental indications and orthodontic models.',
      }
      const titles = {
        'shop-3dps-1': 'DENTIQ Complete Starter',
        'shop-3dps-2': 'DENTIQ Biocompatible',
        'shop-3dps-3': 'DENTIQ Advanced Biocompatible',
        'shop-3dps-4': 'SOL Complete Starter',
        'shop-3dps-5': 'SOL Biocompatible',
        'sol-bundle-us-ca': 'SOL Bundle',
        'shop-3dps-6': 'SOL Advanced Biocompatible',
        'shop-3dps-7': 'SOL Plus Advanced Biocompatible',
        'sol-plus-bundle-us-ca': 'SOL Plus Bundle'
      }
      this.$emit('load-bundle', { 
        tag: bundleTag, 
        description: descriptions[bundleTag] || 'No description available.',
        title: titles[bundleTag] || 'No title available.'
      })
    },
  },
  beforeDestroy() {
    
  },
  watch: {
    
  }
})